// Date formatting utilities for consistent timezone handling

export const formatDateTime = (utcDateString, siteTimezone = 'Australia/Sydney', options = {}) => {
  if (!utcDateString) return 'N/A';
  try {
    const date = new Date(utcDateString);
    return date.toLocaleString('en-AU', {
      timeZone: siteTimezone,
      ...options
    });
  } catch (error) {
    console.error('Date formatting error:', error);
    return new Date(utcDateString).toLocaleString();
  }
};

export const formatDate = (utcDateString, siteTimezone = 'Australia/Sydney') => {
  if (!utcDateString) return 'N/A';
  try {
    const date = new Date(utcDateString);
    return date.toLocaleDateString('en-AU', {
      timeZone: siteTimezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  } catch (error) {
    console.error('Date formatting error:', error);
    return new Date(utcDateString).toLocaleDateString();
  }
};

export const formatTime = (utcDateString, siteTimezone = 'Australia/Sydney') => {
  if (!utcDateString) return 'N/A';
  try {
    const date = new Date(utcDateString);
    return date.toLocaleTimeString('en-AU', {
      timeZone: siteTimezone,
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short'
    });
  } catch (error) {
    console.error('Time formatting error:', error);
    return new Date(utcDateString).toLocaleTimeString();
  }
};
